import axios from 'axios';

export const viajesApi = axios.create({
  baseURL: process.env.REACT_APP_URL_API,
  withCredentials: true
})